import * as Yup from 'yup'

type ResetPasswordFormValues = {
  password: string
  confirmPassword: string
}

export const resetPasswordInitialValues: ResetPasswordFormValues = {
  password: '',
  confirmPassword: '',
}

export const resetPasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Use 8 characters or more for your password')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Password does not match')
    .required('Confirm Password is required'),
})
